import { useState } from "react";
import { renderLineBreaks } from "../../../utils";

import { ChevronUp, ChevronDown } from "../../../lib/icons";
import { ItemListWrapper, AccordionItemWrapper, ItemTitle } from "./styles";

export const AccordionItem = ({ title, description }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <AccordionItemWrapper isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
      <ItemListWrapper>
        <ItemTitle>{renderLineBreaks(title)}</ItemTitle>
        <div>{isOpen ? ChevronUp : ChevronDown}</div>
      </ItemListWrapper>
      <p>{renderLineBreaks(description)}</p>
    </AccordionItemWrapper>
  );
};

export default AccordionItem;
